const kayanganLake =
  "https://img.freepik.com/free-photo/aerial-shot-ocean-surrounded-by-beautiful-mountains-covered-greens_181624-44134.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";

const greenLagoon =
  "https://img.freepik.com/free-photo/wave-landscape-island-sky-nature_1203-3896.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const quinReef =
  "https://img.freepik.com/free-photo/view-island-beach-towel-aerial_1253-817.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const cycBeach =
  "https://img.freepik.com/free-photo/aerial-view-sandy-beach-with-tourists-swimming-beautiful-clear-sea-water-sumilon-island-beach-landing-near-oslob-cebu-philippines-boost-up-color-processing_1253-981.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const lasIslaDeCoral =
  "https://img.freepik.com/free-photo/sand-beach-cebu-water-turquoise_1253-806.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const barracudaLake =
  "https://img.freepik.com/free-photo/beaches-ko-phi-phi-islands-rai-ley-peninsula-are-framed-by-stunning-limestone-cliffs-they-are-regularly-listed-top-beaches-thailand_231208-1465.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const banolBeach =
  "https://img.freepik.com/free-photo/beautiful-beach-view-koh-chang-island-seascape-trad-province-eastern-thailand-blue-sky-background_1150-10256.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const reefGarden =
  "https://img.freepik.com/free-photo/island-covered-trees-vegetation-surrounded-by-ocean_181624-21184.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const twinLagoon =
  "https://img.freepik.com/free-photo/aerial-shot-ocean-surrounded-by-beautiful-mountains-covered-greens_181624-44750.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const atwayanBeach =
  "https://img.freepik.com/free-photo/beautiful-penida-island-bali-indonesia_181624-34276.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const malcapuyaBeach =
  "https://img.freepik.com/free-photo/aerial-shot-small-island-with-few-buildings-boats-blue-dock_181624-12495.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const ditaytayanBeach =
  "https://img.freepik.com/free-photo/aerial-view-sandy-beach-with-tourists-swimming-beautiful-clear-sea-water-sumilon-island-beach-landing-near-oslob-cebu-philippines-boost-up-color-processing_1253-892.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const cocoBeach =
  "https://img.freepik.com/free-photo/aerial-shot-person-swimming-crystal-clear-ocean_181624-44718.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const passIsland =
  "https://images.pexels.com/photos/3507996/pexels-photo-3507996.jpeg?auto=compress&cs=tinysrgb&w=300";
const lusongGunboat =
  "https://img.freepik.com/free-photo/vertical-shot-white-boat-beach-mountains_181624-26341.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const eastAngatWreck =
  "https://images.pexels.com/photos/12643683/pexels-photo-12643683.jpeg?auto=compress&cs=tinysrgb&w=300";
const souvenirShop =
  "https://img.freepik.com/free-photo/side-view-hand-holding-souvenir_23-2149726222.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const maquinitHotspring =
  "https://img.freepik.com/free-photo/beautiful-view-te-puia-geyser-rotorua-new-zealand_181624-45943.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const calauitSafari =
  "https://img.freepik.com/free-photo/closeup-giraffe-zoo_53876-31699.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const cave =
  "https://img.freepik.com/free-photo/low-angle-shot-exit-dark-cave-skrad-croatia_181624-8266.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const dugong =
  "https://images.unsplash.com/photo-1514854560434-dac06a4c6701?w=500&auto=format&fit=crop&q=60";
const dugong2 =
  "https://cdn.pixabay.com/photo/2014/07/08/13/38/manatee-387193_1280.jpg";
const turtle =
  "https://img.freepik.com/free-photo/closeup-green-sea-turtle-swimming-underwater-lights-cool-nature-concepts_181624-24201.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const scubaDiving1 =
  "https://cdn.pixabay.com/photo/2017/05/08/20/50/sub-2296460_640.jpg";
const scubaDiving2 =
  "https://cdn.pixabay.com/photo/2013/02/09/04/33/scuba-diving-79606_640.jpg";
const scubaDiving3 =
  "https://cdn.pixabay.com/photo/2015/11/18/16/38/diving-1049477_640.jpg";
const coron =
  "https://img.freepik.com/free-photo/boats-ocean-surrounded-by-mountains-cloudy-sky_181624-39404.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const sangat =
  "https://img.freepik.com/free-photo/aerial-view-sandy-beach-with-tourists-swimming-beautiful-clear-sea-water-sumilon-island-beach-landing-near-oslob-cebu-philippines-boost-up-color-processing_1253-895.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const culion =
  "https://img.freepik.com/free-photo/aerial-shot-boats-calm-crystal-clear-ocean_181624-45991.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const dibatokIsland =
  "https://img.freepik.com/free-photo/aerial-shot-small-island-with-few-buildings-boats-blue-dock_181624-12495.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const taraIsland =
  "https://img.freepik.com/free-photo/wave-landscape-island-sky-nature_1203-3896.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const northCay =
  "https://img.freepik.com/free-photo/sirithan-beach-sandy-island-ao-nang-thailand_181624-457.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const panlaitan =
  "https://img.freepik.com/free-photo/aerial-view-sandy-beach-with-tourists-swimming-beautiful-clear-sea-water-sumilon-island-beach-landing-near-oslob-cebu-philippines-boost-up-color-processing_1253-956.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const linapacan =
  "https://images.unsplash.com/photo-1547122891-8aae3f2a03dc?w=500&auto=format&fit=crop&q=60";
const boatForAll =
  "https://img.freepik.com/free-photo/long-boat-blue-water-maya-bay-phi-phi-island-krabi-thailand_231208-1500.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";

const imgURL = "https://twintravelcoron.com";

const snorkeling =
  "https://img.freepik.com/free-photo/pipe-shiny-vacation-lens-detail_1232-3094.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const kayaking =
  "https://img.freepik.com/free-photo/girl-canoe_169016-1984.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const sightSeeing =
  "https://img.freepik.com/free-photo/beautiful-young-couple-posing-sea-beach-love-tenderness_1296-915.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const pictureTaking =
  "https://img.freepik.com/free-photo/young-company-friends-sightseeing-taking-pictures-traveling-thailand_285396-3658.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";

const elNido1 =
  "https://img.freepik.com/free-photo/aerial-shot-ocean-surrounded-by-beautiful-mountains-covered-greens_181624-44134.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const elNido2 =
  "https://img.freepik.com/free-photo/long-boat-blue-water-maya-bay-phi-phi-island-krabi-thailand_335224-895.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const elNido3 =
  "https://img.freepik.com/free-photo/pileh-blue-lagoon-phi-phi-island-thailand_231208-1487.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";
const elNido4 =
  "https://img.freepik.com/free-photo/female-tourist-leaning-boat-travel-near-cliff_23-2148153858.jpg?ga=GA1.1.987006646.1737491457&semt=ais_hybrid";

const blackIsland = imgURL + "/islands/black-island.jpg";
const centennialShrine = imgURL + "/islands/centennial-shrine.jpg";
const coronChurch = imgURL + "/islands/coron-church.jpg";
const fireflies = imgURL + "/islands/fireflies.jpg";
const lualhatiPark = imgURL + "/islands/lualhati-park.jpg";
const malbatoChurch = imgURL + "/islands/malbato-church.jpg";
const mtTapyas = imgURL + "/islands/mt-tapyas.jpg";
const plankton = imgURL + "/islands/plankton.jpg";
const puerto1 = imgURL + "/islands/puerto1.jpg";
const puerto2 = imgURL + "/islands/puerto2.jpg";
const puerto3 = imgURL + "/islands/puerto3.jpg";
const puerto4 = imgURL + "/islands/puerto4.jpg";

// ! CHANGE ALL THE IMAGE FILE NAME , no parenthesis and space

const BacauBay1 = imgURL + "/hotels/BacauBay/image.jpg";
const BacauBay2 = imgURL + "/hotels/BacauBay/image1.jpg";
const BacauBay3 = imgURL + "/hotels/BacauBay/image2.jpg";
const BacauBay4 = imgURL + "/hotels/BacauBay/image3.jpg";

const FunnyLion1 = imgURL + "/hotels/FunnyLion/image.jpg";
const FunnyLion2 = imgURL + "/hotels/FunnyLion/image1.jpg";
const FunnyLion3 = imgURL + "/hotels/FunnyLion/image2.jpg";
const FunnyLion4 = imgURL + "/hotels/FunnyLion/image3.jpg";

const PrimTravellersInn1 = imgURL + "/hotels/PrimTravellersInn/image.jpg";
const PrimTravellersInn2 = imgURL + "/hotels/PrimTravellersInn/image1.jpg";
const PrimTravellersInn3 = imgURL + "/hotels/PrimTravellersInn/image2.jpg";
const PrimTravellersInn4 = imgURL + "/hotels/PrimTravellersInn/image3.jpg";
const PrimTravellersInn5 = imgURL + "/hotels/PrimTravellersInn/image4.jpg";
const PrimTravellersInn6 = imgURL + "/hotels/PrimTravellersInn/image5.jpg";

const SunLightHotel1 = imgURL + "/hotels/SunlightHotel/image.jpg";
const SunLightHotel2 = imgURL + "/hotels/SunlightHotel/image-1.jpg";
const SunLightHotel3 = imgURL + "/hotels/SunlightHotel/image-2.jpg";

const SunzEnCoron1 = imgURL + "/hotels/SunzEnCoron/image.jpg";
const SunzEnCoron2 = imgURL + "/hotels/SunzEnCoron/image1.jpg";
const SunzEnCoron3 = imgURL + "/hotels/SunzEnCoron/image2.jpg";
const SunzEnCoron4 = imgURL + "/hotels/SunzEnCoron/image3.jpg";

const TagResort1 = imgURL + "/hotels/TagResort/image.jpg";
const TagResort2 = imgURL + "/hotels/TagResort/image1.jpg";
const TagResort3 = imgURL + "/hotels/TagResort/image2.jpg";

// const TheRidge1 = imgURL + "/hotels/TheRidge/image.jpg";

const TwoSeason1 = imgURL + "/hotels/TwoSeason/image.jpg";
const TwoSeason2 = imgURL + "/hotels/TwoSeason/image2.jpg";
const TwoSeason3 = imgURL + "/hotels/TwoSeason/image3.jpg";
const TwoSeason4 = imgURL + "/hotels/TwoSeason/image4.jpg";

const VenusRoyaleHotel1 = imgURL + "/hotels/VenusRoyaleHotel/image.jpg";
const VenusRoyaleHotel2 = imgURL + "/hotels/VenusRoyaleHotel/image1.jpg";
const VenusRoyaleHotel3 = imgURL + "/hotels/VenusRoyaleHotel/image2.jpg";
const VenusRoyaleHotel4 = imgURL + "/hotels/VenusRoyaleHotel/image3.jpg";
const VenusRoyaleHotel5 = imgURL + "/hotels/VenusRoyaleHotel/image4.jpg";
const VenusRoyaleHotel6 = imgURL + "/hotels/VenusRoyaleHotel/image5.jpg";
const VenusRoyaleHotel7 = imgURL + "/hotels/VenusRoyaleHotel/image6.jpg";
const VenusRoyaleHotel8 = imgURL + "/hotels/VenusRoyaleHotel/image7.jpg";

const ViennaHotel1 = imgURL + "/hotels/ViennaHotel/image.jpg";
const ViennaHotel2 = imgURL + "/hotels/ViennaHotel/image1.jpg";
const ViennaHotel3 = imgURL + "/hotels/ViennaHotel/image2.jpg";
const ViennaHotel4 = imgURL + "/hotels/ViennaHotel/image3.jpg";
const ViennaHotel5 = imgURL + "/hotels/ViennaHotel/image4.jpg";

const WestownHotel1 = imgURL + "/hotels/WestownHotel/image.jpg";
const WestownHotel2 = imgURL + "/hotels/WestownHotel/image1.jpg";
const WestownHotel3 = imgURL + "/hotels/WestownHotel/image2.jpg";
const WestownHotel4 = imgURL + "/hotels/WestownHotel/image3.jpg";

const WestownLagoon1 = imgURL + "/hotels/WestownLagoon/image.jpg";
const WestownLagoon2 = imgURL + "/hotels/WestownLagoon/image1.jpg";

const Zuri1 = imgURL + "/hotels/Zuri/image.jpg";
const Zuri2 = imgURL + "/hotels/Zuri/image1.jpg";
const Zuri3 = imgURL + "/hotels/Zuri/image2.jpg";
const Zuri4 = imgURL + "/hotels/Zuri/image3.jpg";
const Zuri5 = imgURL + "/hotels/Zuri/image4.jpg";
const Zuri6 = imgURL + "/hotels/Zuri/image5.jpg";

const tours = [
  // Joiners Tours
  {
    id: 1,
    name: "Coron Island Tour A",
    basePrice: 1200,
    rating: "4.8",
    desc: "Discover the breathtaking beauty of Coron’s crystal-clear lakes, vibrant coral reefs, and stunning beaches.",
    longDescription:
      "Experience a day of island-hopping adventure in Coron, where you’ll visit iconic sites like Kayangan Lake, the Green Lagoon, and CYC Beach. Snorkel in vibrant coral reefs, relax on pristine beaches, and take in the breathtaking scenery.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${kayanganLake}`,
      `${greenLagoon}`,
      `${quinReef}`,
      `${cycBeach}`,
      `${lasIslaDeCoral}`,
      `${eastAngatWreck}`,
    ],
    variants: [
      { type: "Adult", price: 1200 },
      { type: "Kid 4-6 years old", price: 600 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Kayangan Lake",
      "Green Lagoon",
      "Quin Reef",
      "CYC Beach",
      "Las Isla de Coral",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
      "Tourist Boat",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 2,
    name: "Coron Island Tour B",
    basePrice: 1400,
    rating: "4.8",
    desc: "Immerse yourself in the wonders of Coron with a visit to hidden lagoons, shipwrecks, and pristine beaches.",
    longDescription:
      "Embark on a scenic tour of Coron’s hidden gems, from the enchanting Twin Lagoon to the historic Skeleton Wreck. Swim in clear waters, explore unique marine life, and enjoy a fun-filled island adventure.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${banolBeach}`,
      `${barracudaLake}`,
      `${reefGarden}`,
      `${twinLagoon}`,
    ],
    variants: [
      { type: "Adult", price: 1400 },
      { type: "Kid 4-6 years old", price: 700 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Barracuda Lake",
      "Banol Beach or Shaniah Cottage",
      "Skeleton Wreck",
      "Reef Garden",
      "Twin Lagoon",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
      "Tourist Boat",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 3,
    name: "Coron Ultimate Tour",
    basePrice: 1700,
    rating: "4.8",
    desc: "Experience the best of Coron’s top attractions in one ultimate island-hopping adventure.",
    longDescription:
      "Get the full Coron experience in one day! Visit top destinations, including Kayangan Lake, Twin Lagoon, and Coral Garden. Enjoy snorkeling, sightseeing, and picture-taking in this must-try island tour.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${lasIslaDeCoral}`,
      `${kayanganLake}`,
      `${twinLagoon}`,
      `${atwayanBeach}`,
      `${cycBeach}`,
    ],
    variants: [
      { type: "Adult", price: 1700 },
      { type: "Kid 4-6 years old", price: 850 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Kayangan Lake",
      "Las Isla de Coral",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
      "Tourist Boat",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 4,
    name: "Super Ultimate Tour",
    basePrice: 1900,
    rating: "4.8",
    desc: "The ultimate Coron adventure, covering its most iconic spots, from hidden lakes to vibrant reefs.",
    longDescription:
      "Take your island adventure to the next level with this all-in-one tour of Coron’s top attractions, including hidden lakes, stunning beaches, and vibrant snorkeling sites. Perfect for adventure seekers.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${barracudaLake}`,
      `${kayanganLake}`,
      `${twinLagoon}`,
      `${atwayanBeach}`,
      `${cycBeach}`,
    ],
    variants: [
      { type: "Adult", price: 1900 },
      { type: "Kid 4-6 years old", price: 950 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
      "Tourist Boat",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 5,
    name: "Island Escapade Tour",
    basePrice: 1600,
    rating: "4.8",
    desc: "Relax on the finest beaches of Coron, with powdery white sand and turquoise waters.",
    longDescription:
      "Escape to paradise with a visit to Coron’s most beautiful islands, including Malcapuya, Ditaytayan, and Banana Beach. Sunbathe, swim, and snorkel in the crystal-clear waters of these tropical havens.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [`${malcapuyaBeach}`, `${ditaytayanBeach}`, `${cocoBeach}`],
    variants: [
      { type: "Adult", price: 1600 },
      { type: "Kid 4-6 years old", price: 800 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Malcapuya Beach",
      "Ditaytayan Beach",
      "Banana Beach or Coco Beach",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 6,
    name: "Reefs and Wrecks Tour",
    basePrice: 1600,
    rating: "4.8",
    desc: "Dive into history and nature as you explore sunken WWII shipwrecks and stunning coral gardens.",
    longDescription:
      "Explore Coron’s famous WWII shipwrecks and vibrant coral gardens. This tour is perfect for snorkeling and diving enthusiasts who want to experience a mix of history and marine biodiversity.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${passIsland}`,
      `${lusongGunboat}`,
      `${eastAngatWreck}`,
      `${coron}`,
    ],
    variants: [
      { type: "Adult", price: 1600 },
      { type: "Kid 4-6 years old", price: 800 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Pass Island",
      "Lusong Gunboat",
      "Lusong Coral Garden",
      "East Tangat Wreck",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 7,
    name: "Coron Town Tour",
    basePrice: 700,
    rating: "4.8",
    desc: "Discover Coron’s rich history, culture, and scenic views with this guided town exploration..",
    longDescription:
      "Uncover the charm of Coron town with a guided tour to Mt. Tapyas, Maquinit Hot Springs, and historical landmarks. A perfect mix of culture, relaxation, and sightseeing.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "3:00-3:30 PM",
    duration: "4 hours",
    imgArray: [
      `${mtTapyas}`,
      `${lualhatiPark}`,
      `${souvenirShop}`,
      `${centennialShrine}`,
      `${maquinitHotspring}`,
      `${coronChurch}`,
    ],
    variants: [
      { type: "Adult", price: 700 },
      { type: "Kid 4-6 years old", price: 350 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Lualhati Park",
      "Souvenir Shops",
      "Centenial Shrine",
      "Mt. Tapyas View Deck",
      "Maquinit Hot Spring",
      "Coron Church (Optional)",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 8,
    name: "Calauit Safari Tour",
    basePrice: 2600,
    rating: "4.8",
    desc: "Encounter exotic wildlife in Calauit Safari Park and explore the serene beauty of Busuanga.",
    longDescription:
      "Witness exotic African wildlife in Calauit Safari Park, home to giraffes, zebras, and other animals. Enjoy a scenic countryside journey and explore Busuanga’s hidden natural wonders.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "7:30-8:00 AM",
    duration: "9 hours",
    imgArray: [
      `${calauitSafari}`,
      `${blackIsland}`,
      `${malbatoChurch}`,
      `${cave}`,
    ],
    variants: [
      { type: "Adult", price: 2600 },
      { type: "Kid 4-6 years old", price: 1300 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    destinations: [
      "Calauit Wildlife Safari",
      "Black Island",
      "Malbato Church",
      "Cave",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 9,
    name: "Fireflies & Plankton Tour",
    basePrice: 950,
    rating: "4.8",
    desc: "Cruise through Coron’s waters at night and witness glowing fireflies and bioluminescent plankton light up the darkness.",
    longDescription:
      "Experience a magical night in Coron as you drift through mangroves illuminated by fireflies. Watch as bioluminescent plankton glow with every movement, creating a breathtaking natural light show. Perfect for nature lovers seeking a touch of wonder under the stars.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "6:00-6:30 PM",
    duration: "3 hours",
    imgArray: [`${fireflies}`, `${plankton}`, `${boatForAll}`],
    variants: [
      { type: "Adult", price: 950 },
      { type: "Kid 4-6 years old", price: 475 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: ["Dinner", "Pick up & Drop off Service", "Kayak", "Tour Guide"],
  },
  {
    id: 10,
    name: "Dugong & Turtle Watching",
    basePrice: 5000,
    rating: "4.8",
    desc: "Experience a once-in-a-lifetime opportunity to swim alongside dugongs and sea turtles in their natural habitat.",
    longDescription:
      "Join us on an unforgettable adventure in Coron, where you'll get the chance to observe the gentle dugongs and graceful sea turtles up close. This eco-friendly tour takes you to prime snorkeling spots, allowing you to witness marine life in crystal-clear waters. With expert guides ensuring a safe and informative experience, you'll learn about conservation efforts and the importance of protecting these magnificent creatures. The tour includes hotel pickup, boat transfers, a delicious meal, and high-quality snorkeling gear, ensuring a seamless and enjoyable day.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [`${dugong}`, `${dugong2}`, `${turtle}`, `${coron}`],
    variants: [
      { type: "Adult", price: 5000 },
      { type: "Kid 4-6 years old", price: 2500 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Food",
      "Entrance Fee",
      "Tour Guide",
      "Pick up & Drop off Service",
      "Boat",
      "Mask, Fins and Snorkel",
    ],
  },
  {
    id: 11,
    name: "Discover Scuba Diving",
    basePrice: 6000,
    rating: "4.8",
    desc: "Take your first breath underwater and explore the vibrant marine life of Coron with professional instructors.",
    longDescription:
      "Discover the thrill of scuba diving even if you've never dived before! This beginner-friendly experience in Coron allows you to explore the underwater world with a professional instructor. You'll receive a short briefing on safety and techniques before heading into the warm waters for your first dive. Encounter stunning coral reefs, tropical fish, and even hidden shipwrecks. Whether you're looking for a new adventure or considering getting certified, this tour is the perfect introduction to scuba diving. The package includes two dives, equipment rental, a licensed instructor, boat transfers, and meals.",
    typeOfTour: "Joiners",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${scubaDiving1}`,
      `${scubaDiving2}`,
      `${scubaDiving3}`,
      `${coron}`,
    ],
    variants: [
      { type: "Without License 2 Dives", price: 6000 },
      { type: "Fundives with License", price: 5000 },
    ],
    inclusions: [
      "Food",
      "Entrance Fee",
      "Tour Guide",
      "Pick up & Drop off Service",
      "Boat",
      "Mask, Fins and Snorkel",
    ],
  },
  {
    id: 12,
    name: "Coron Town Tour | Private",
    basePrice: 2600,
    rating: "4.8",
    desc: "Discover Coron’s rich history, culture, and scenic views with this guided town exploration..",
    longDescription:
      "Uncover the charm of Coron town with a guided tour to Mt. Tapyas, Maquinit Hot Springs, and historical landmarks. A perfect mix of culture, relaxation, and sightseeing.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "3:00-3:30 PM",
    duration: "4 hours",
    imgArray: [
      `${souvenirShop}`,
      `${mtTapyas}`,
      `${lualhatiPark}`,
      `${centennialShrine}`,
      `${maquinitHotspring}`,
      `${coronChurch}`,
    ],
    variants: [
      { type: "Adult (1 pax)", price: 2600 },
      { type: "Adult (2 pax)", price: 3400 },
      { type: "Adult (3 pax)", price: 5100 },
      { type: "Adult (4 pax)", price: 6000 },
      { type: "Adult (5 pax)", price: 7500 },
      { type: "Adult (6 pax)", price: 7200 },
      { type: "Adult (7 pax)", price: 8400 },
      { type: "Adult (8 pax)", price: 9600 },
      { type: "Adult (9 pax)", price: 9450 },
      { type: "Adult (10 pax)", price: 10500 },
      { type: "Adult (11 pax)", price: 9900 },
      { type: "Adult (12 pax)", price: 10800 },
      { type: "Adult (13 pax)", price: 11700 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (1 pax)", price: 1300 },
          { for: "Adult (2 pax)", price: 850 },
          { for: "Adult (3 pax)", price: 850 },
          { for: "Adult (4 pax)", price: 750 },
          { for: "Adult (5 pax)", price: 750 },
          { for: "Adult (6 pax)", price: 600 },
          { for: "Adult (7 pax)", price: 600 },
          { for: "Adult (8 pax)", price: 600 },
          { for: "Adult (9 pax)", price: 525 },
          { for: "Adult (10 pax)", price: 525 },
          { for: "Adult (11 pax)", price: 450 },
          { for: "Adult (12 pax)", price: 450 },
          { for: "Adult (13 pax)", price: 450 },
        ],
      },
    ],
    destinations: [
      "Lualhati Park",
      "Souvenir Shops",
      "Centenial Shrine",
      "Mt. Tapyas View Deck",
      "Maquinit Hot Spring",
      "Coron Church (Optional)",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 13,
    name: "Coron Island Tour A | Private",
    basePrice: 5000,
    rating: "4.8",
    desc: "Discover the breathtaking beauty of Coron’s crystal-clear lakes, vibrant coral reefs, and stunning beaches.",
    longDescription:
      "Experience a day of island-hopping adventure in Coron, where you’ll visit iconic sites like Kayangan Lake, the Green Lagoon, and CYC Beach. Snorkel in vibrant coral reefs, relax on pristine beaches, and take in the breathtaking scenery.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${cycBeach}`,
      `${kayanganLake}`,
      `${greenLagoon}`,
      `${quinReef}`,
      `${lasIslaDeCoral}`,
      `${eastAngatWreck}`,
    ],
    variants: [
      { type: "Adult (1 pax)", price: 5000 },
      { type: "Adult (2 pax)", price: 6600 },
      { type: "Adult (3 pax)", price: 9900 },
      { type: "Adult (4 pax)", price: 11200 },
      { type: "Adult (5 pax)", price: 14000 },
      { type: "Adult (6 pax)", price: 15000 },
      { type: "Adult (7 pax)", price: 17500 },
      { type: "Adult (8 pax)", price: 20000 },
      { type: "Adult (9 pax)", price: 17100 },
      { type: "Adult (10 pax)", price: 19000 },
      { type: "Adult (11 pax)", price: 17600 },
      { type: "Adult (12 pax)", price: 19200 },
      { type: "Adult (13 pax)", price: 20800 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (1 pax)", price: 2500 },
          { for: "Adult (2 pax)", price: 1650 },
          { for: "Adult (3 pax)", price: 1650 },
          { for: "Adult (4 pax)", price: 1400 },
          { for: "Adult (5 pax)", price: 1400 },
          { for: "Adult (6 pax)", price: 1250 },
          { for: "Adult (7 pax)", price: 1250 },
          { for: "Adult (8 pax)", price: 1250 },
          { for: "Adult (9 pax)", price: 950 },
          { for: "Adult (10 pax)", price: 950 },
          { for: "Adult (11 pax)", price: 800 },
          { for: "Adult (12 pax)", price: 800 },
          { for: "Adult (13 pax)", price: 800 },
        ],
      },
    ],
    destinations: [
      "Kayangan Lake",
      "Green Lagoon",
      "Quin Reef",
      "CYC Beach",
      "Las Isla de Coral",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 14,
    name: "Coron Island Tour B | Private",
    basePrice: 5200,
    rating: "4.8",
    desc: "Immerse yourself in the wonders of Coron with a visit to hidden lagoons, shipwrecks, and pristine beaches.",
    longDescription:
      "Embark on a scenic tour of Coron’s hidden gems, from the enchanting Twin Lagoon to the historic Skeleton Wreck. Swim in clear waters, explore unique marine life, and enjoy a fun-filled island adventure.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${reefGarden}`,
      `${banolBeach}`,
      `${barracudaLake}`,
      `${twinLagoon}`,
    ],
    variants: [
      { type: "Adult (1 pax)", price: 5200 },
      { type: "Adult (2 pax)", price: 7000 },
      { type: "Adult (3 pax)", price: 10500 },
      { type: "Adult (4 pax)", price: 12000 },
      { type: "Adult (5 pax)", price: 15000 },
      { type: "Adult (6 pax)", price: 16200 },
      { type: "Adult (7 pax)", price: 18900 },
      { type: "Adult (8 pax)", price: 21600 },
      { type: "Adult (9 pax)", price: 19800 },
      { type: "Adult (10 pax)", price: 22000 },
      { type: "Adult (11 pax)", price: 19800 },
      { type: "Adult (12 pax)", price: 21600 },
      { type: "Adult (13 pax)", price: 23400 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (1 pax)", price: 2600 },
          { for: "Adult (2 pax)", price: 1750 },
          { for: "Adult (3 pax)", price: 1750 },
          { for: "Adult (4 pax)", price: 1500 },
          { for: "Adult (5 pax)", price: 1500 },
          { for: "Adult (6 pax)", price: 1350 },
          { for: "Adult (7 pax)", price: 1350 },
          { for: "Adult (8 pax)", price: 1350 },
          { for: "Adult (9 pax)", price: 1100 },
          { for: "Adult (10 pax)", price: 1100 },
          { for: "Adult (11 pax)", price: 900 },
          { for: "Adult (12 pax)", price: 900 },
          { for: "Adult (13 pax)", price: 900 },
        ],
      },
    ],
    destinations: [
      "Barracuda Lake",
      "Banol Beach or Shaniah Cottage",
      "Skeleton Wreck",
      "Reef Garden",
      "Twin Lagoon",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 15,
    name: "Coron Ultimate Tour | Private",
    basePrice: 5800,
    rating: "4.8",
    desc: "Experience the best of Coron’s top attractions in one ultimate island-hopping adventure.",
    longDescription:
      "Get the full Coron experience in one day! Visit top destinations, including Kayangan Lake, Twin Lagoon, and Coral Garden. Enjoy snorkeling, sightseeing, and picture-taking in this must-try island tour.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${twinLagoon}`,
      `${lasIslaDeCoral}`,
      `${kayanganLake}`,
      `${atwayanBeach}`,
      `${cycBeach}`,
    ],
    variants: [
      { type: "Adult (1 pax)", price: 5800 },
      { type: "Adult (2 pax)", price: 7400 },
      { type: "Adult (3 pax)", price: 11100 },
      { type: "Adult (4 pax)", price: 13200 },
      { type: "Adult (5 pax)", price: 16500 },
      { type: "Adult (6 pax)", price: 15600 },
      { type: "Adult (7 pax)", price: 18200 },
      { type: "Adult (8 pax)", price: 20800 },
      { type: "Adult (9 pax)", price: 20700 },
      { type: "Adult (10 pax)", price: 23000 },
      { type: "Adult (11 pax)", price: 22000 },
      { type: "Adult (12 pax)", price: 24000 },
      { type: "Adult (13 pax)", price: 26000 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (1 pax)", price: 2900 },
          { for: "Adult (2 pax)", price: 1850 },
          { for: "Adult (3 pax)", price: 1850 },
          { for: "Adult (4 pax)", price: 1650 },
          { for: "Adult (5 pax)", price: 1650 },
          { for: "Adult (6 pax)", price: 1300 },
          { for: "Adult (7 pax)", price: 1300 },
          { for: "Adult (8 pax)", price: 1300 },
          { for: "Adult (9 pax)", price: 1150 },
          { for: "Adult (10 pax)", price: 1150 },
          { for: "Adult (11 pax)", price: 1000 },
          { for: "Adult (12 pax)", price: 1000 },
          { for: "Adult (13 pax)", price: 1000 },
        ],
      },
    ],
    destinations: [
      "Kayangan Lake",
      "Las Isla de Coral",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 16,
    name: "Super Ultimate Tour | Private",
    basePrice: 6000,
    rating: "4.8",
    desc: "The ultimate Coron adventure, covering its most iconic spots, from hidden lakes to vibrant reefs.",
    longDescription:
      "Take your island adventure to the next level with this all-in-one tour of Coron’s top attractions, including hidden lakes, stunning beaches, and vibrant snorkeling sites. Perfect for adventure seekers.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${atwayanBeach}`,
      `${barracudaLake}`,
      `${kayanganLake}`,
      `${twinLagoon}`,
      `${cycBeach}`,
    ],
    variants: [
      { type: "Adult (1 pax)", price: 6000 },
      { type: "Adult (2 pax)", price: 7600 },
      { type: "Adult (3 pax)", price: 11400 },
      { type: "Adult (4 pax)", price: 12800 },
      { type: "Adult (5 pax)", price: 16000 },
      { type: "Adult (6 pax)", price: 16200 },
      { type: "Adult (7 pax)", price: 18900 },
      { type: "Adult (8 pax)", price: 21600 },
      { type: "Adult (9 pax)", price: 21600 },
      { type: "Adult (10 pax)", price: 24000 },
      { type: "Adult (11 pax)", price: 23100 },
      { type: "Adult (12 pax)", price: 25200 },
      { type: "Adult (13 pax)", price: 27300 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (1 pax)", price: 3000 },
          { for: "Adult (2 pax)", price: 1400 },
          { for: "Adult (3 pax)", price: 1400 },
          { for: "Adult (4 pax)", price: 1600 },
          { for: "Adult (5 pax)", price: 1600 },
          { for: "Adult (6 pax)", price: 1350 },
          { for: "Adult (7 pax)", price: 1350 },
          { for: "Adult (8 pax)", price: 1350 },
          { for: "Adult (9 pax)", price: 1200 },
          { for: "Adult (10 pax)", price: 1200 },
          { for: "Adult (11 pax)", price: 1050 },
          { for: "Adult (12 pax)", price: 1050 },
          { for: "Adult (13 pax)", price: 1050 },
        ],
      },
    ],
    destinations: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 17,
    name: "Island Escapade Tour | Private",
    basePrice: 4200,
    rating: "4.8",
    desc: "Relax on the finest beaches of Coron, with powdery white sand and turquoise waters.",
    longDescription:
      "Escape to paradise with a visit to Coron’s most beautiful islands, including Malcapuya, Ditaytayan, and Banana Beach. Sunbathe, swim, and snorkel in the crystal-clear waters of these tropical havens.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [`${ditaytayanBeach}`, `${malcapuyaBeach}`, `${cocoBeach}`],
    variants: [
      { type: "Adult (1 pax)", price: 6700 },
      { type: "Adult (2 pax)", price: 8400 },
      { type: "Adult (3 pax)", price: 12600 },
      { type: "Adult (4 pax)", price: 11600 },
      { type: "Adult (5 pax)", price: 14500 },
      { type: "Adult (6 pax)", price: 15000 },
      { type: "Adult (7 pax)", price: 17500 },
      { type: "Adult (8 pax)", price: 20000 },
      { type: "Adult (9 pax)", price: 20700 },
      { type: "Adult (10 pax)", price: 23000 },
      { type: "Adult (11 pax)", price: 23100 },
      { type: "Adult (12 pax)", price: 25200 },
      { type: "Adult (13 pax)", price: 27300 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (1 pax)", price: 3350 },
          { for: "Adult (2 pax)", price: 2100 },
          { for: "Adult (3 pax)", price: 2100 },
          { for: "Adult (4 pax)", price: 1450 },
          { for: "Adult (5 pax)", price: 1450 },
          { for: "Adult (6 pax)", price: 1250 },
          { for: "Adult (7 pax)", price: 1250 },
          { for: "Adult (8 pax)", price: 1250 },
          { for: "Adult (9 pax)", price: 1150 },
          { for: "Adult (10 pax)", price: 1150 },
          { for: "Adult (11 pax)", price: 1050 },
          { for: "Adult (12 pax)", price: 1050 },
          { for: "Adult (13 pax)", price: 1050 },
        ],
      },
    ],
    destinations: [
      "Malcapuya Beach",
      "Ditaytayan Beach",
      "Banana Beach or Coco Beach",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 18,
    name: "Reefs and Wrecks Tour | Private",
    basePrice: 4200,
    rating: "4.8",
    desc: "Dive into history and nature as you explore sunken WWII shipwrecks and stunning coral gardens.",
    longDescription:
      "Explore Coron’s famous WWII shipwrecks and vibrant coral gardens. This tour is perfect for snorkeling and diving enthusiasts who want to experience a mix of history and marine biodiversity.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${lusongGunboat}`,
      `${passIsland}`,
      `${eastAngatWreck}`,
      `${coron}`,
    ],
    variants: [
      { type: "Adult (1 pax)", price: 6700 },
      { type: "Adult (2 pax)", price: 8400 },
      { type: "Adult (3 pax)", price: 12600 },
      { type: "Adult (4 pax)", price: 11600 },
      { type: "Adult (5 pax)", price: 14500 },
      { type: "Adult (6 pax)", price: 15000 },
      { type: "Adult (7 pax)", price: 17500 },
      { type: "Adult (8 pax)", price: 20000 },
      { type: "Adult (9 pax)", price: 20700 },
      { type: "Adult (10 pax)", price: 23000 },
      { type: "Adult (11 pax)", price: 23100 },
      { type: "Adult (12 pax)", price: 25200 },
      { type: "Adult (13 pax)", price: 27300 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (1 pax)", price: 3350 },
          { for: "Adult (2 pax)", price: 2100 },
          { for: "Adult (3 pax)", price: 2100 },
          { for: "Adult (4 pax)", price: 1450 },
          { for: "Adult (5 pax)", price: 1450 },
          { for: "Adult (6 pax)", price: 1250 },
          { for: "Adult (7 pax)", price: 1250 },
          { for: "Adult (8 pax)", price: 1250 },
          { for: "Adult (9 pax)", price: 1150 },
          { for: "Adult (10 pax)", price: 1150 },
          { for: "Adult (11 pax)", price: 1050 },
          { for: "Adult (12 pax)", price: 1050 },
          { for: "Adult (13 pax)", price: 1050 },
        ],
      },
    ],
    destinations: [
      "Pass Island",
      "Lusong Gunboat",
      "Lusong Coral Garden",
      "East Tangat Wreck",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 19,
    name: "Calauit Safari Tour | Private",
    basePrice: 6600,
    rating: "4.8",
    desc: "Encounter exotic wildlife in Calauit Safari Park and explore the serene beauty of Busuanga.",
    longDescription:
      "Witness exotic African wildlife in Calauit Safari Park, home to giraffes, zebras, and other animals. Enjoy a scenic countryside journey and explore Busuanga’s hidden natural wonders.",
    typeOfTour: "Private",
    days: "1 Day",
    location: "Coron",
    package: "Day Tour",
    pickUpTime: "7:30-8:00 AM",
    duration: "9 hours",
    imgArray: [
      `${blackIsland}`,
      `${calauitSafari}`,
      `${malbatoChurch}`,
      `${cave}`,
    ],
    variants: [
      { type: "Adult (2 pax)", price: 13200 },
      { type: "Adult (3 pax)", price: 19800 },
      { type: "Adult (4 pax)", price: 15600 },
      { type: "Adult (5 pax)", price: 19500 },
      { type: "Adult (6 pax)", price: 19800 },
      { type: "Adult (7 pax)", price: 23100 },
      { type: "Adult (8 pax)", price: 26400 },
      { type: "Adult (9 pax)", price: 25200 },
      { type: "Adult (10 pax)", price: 28000 },
      { type: "Adult (11 pax)", price: 27500 },
      { type: "Adult (12 pax)", price: 30000 },
      { type: "Adult (13 pax)", price: 32500 },
      { type: "Adult (+13 pax)?", price: null },
      { type: "Infant 3 years old and below", price: 0 },
      {
        type: "Kid (Add to cart as needed)",
        price: [
          { for: "Adult (2 pax)", price: 3300 },
          { for: "Adult (3 pax)", price: 3300 },
          { for: "Adult (4 pax)", price: 1950 },
          { for: "Adult (5 pax)", price: 1950 },
          { for: "Adult (6 pax)", price: 1650 },
          { for: "Adult (7 pax)", price: 1650 },
          { for: "Adult (8 pax)", price: 1650 },
          { for: "Adult (9 pax)", price: 1400 },
          { for: "Adult (10 pax)", price: 1400 },
          { for: "Adult (11 pax)", price: 1250 },
          { for: "Adult (12 pax)", price: 1250 },
          { for: "Adult (13 pax)", price: 1250 },
        ],
      },
    ],
    destinations: [
      "Calauit Wildlife Safari",
      "Black Island",
      "Malbato Church",
      "Cave",
    ],
    inclusions: [
      "Pick up and Drop off Service",
      "Buffet Lunch",
      "Drinking Water",
      "Island Fee",
      "Life Vest",
      "Tour Guide",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    exclusions: [
      "Mask/Snorkle - ₱ 150",
      "Fins - ₱ 150",
      "Aqua Shoes - ₱ 150",
      "Colored Kayak - ₱ 1,000",
      "Mask/Snorkle - ₱ 1,500",
      "Go Pro - ₱ 1,500",
    ],
  },
  {
    id: 20,
    name: "Coron Island | Boat Rental",
    basePrice: 3500,
    rating: "4.7",
    desc: "Explore the stunning Coron Island with a private boat rental, perfect for island hopping and snorkeling adventures.",
    longDescription:
      "Discover the breathtaking beauty of Coron Island with a private boat rental. This tour allows you to explore iconic destinations, such as Kayangan Lake, Twin Lagoon, and Skeleton Wreck at your own pace. Enjoy crystal-clear waters, white sandy beaches, and vibrant marine life as you sail through the islands. Ideal for small or large groups looking for an exclusive and personalized island-hopping experience.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "7:30-8:00 AM",
    duration: "9 hours",
    imgArray: [`${coron}`, `${boatForAll}`],
    variants: [
      { type: "2-4 pax", price: 3500 },
      { type: "5-8 pax", price: 4000 },
      { type: "9-15 pax", price: 4500 },
      { type: "16-20 pax", price: 5700 },
      { type: "21-24 pax", price: 6700 },
      { type: "25-30 pax", price: 7000 },
    ],
  },
  {
    id: 21,
    name: "Sangat or Lusong | Boat Rental",
    basePrice: 4850,
    rating: "4.8",
    desc: "Snorkel through the historic Lusong Gunboat Wreck and relax at the pristine beaches of Sangat Island.",
    longDescription:
      "Embark on an unforgettable adventure exploring Sangat Island and Lusong. Dive into crystal-clear waters to witness the famous Lusong Gunboat Wreck, a shallow WWII wreck covered in vibrant corals. Relax on the white sandy beaches of Sangat Island, surrounded by lush greenery and peaceful waters.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "8:00 AM",
    duration: "8 hours",
    imgArray: [`${sangat}`, `${boatForAll}`],
    variants: [
      { type: "2-4 pax", price: 4850 },
      { type: "5-8 pax", price: 5400 },
      { type: "9-15 pax", price: 6500 },
      { type: "16-20 pax", price: 7600 },
      { type: "21-24 pax", price: 8700 },
      { type: "25-30 pax", price: 9800 },
    ],
  },
  {
    id: 22,
    name: "Malcapuya | Boat Rental",
    basePrice: 5700,
    rating: "4.9",
    desc: "Experience the untouched paradise of Malcapuya Island with its powdery white sand and crystal-clear waters.",
    longDescription:
      "Malcapuya Island is known for its stunning long stretch of fine white sand and turquoise waters, often compared to Boracay but with fewer crowds. Enjoy a relaxing beach getaway, snorkeling in vibrant coral reefs, and the peaceful ambiance of this secluded island.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "8:00 AM",
    duration: "8 hours",
    imgArray: [`${malcapuyaBeach}`, `${boatForAll}`],
    variants: [
      { type: "2-4 pax", price: 5700 },
      { type: "5-8 pax", price: 7000 },
      { type: "9-15 pax", price: 8500 },
      { type: "16-20 pax", price: 9000 },
      { type: "21-24 pax", price: 10000 },
      { type: "25-30 pax", price: 11200 },
    ],
  },
  {
    id: 23,
    name: "Culion Mun. | Boat Rental",
    basePrice: 4850,
    rating: "4.7",
    desc: "Discover the historic charm of Culion, once a leper colony, now a peaceful island filled with cultural and natural wonders.",
    longDescription:
      "Visit Culion, a fascinating island rich in history and natural beauty. Explore the old Spanish fortress, museum, and stunning coastal landscapes. Experience the island’s friendly locals and tranquil atmosphere, perfect for those seeking a mix of history and relaxation.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "8:00 AM",
    duration: "8 hours",
    imgArray: [`${culion}`, `${boatForAll}`],
    variants: [
      { type: "2-4 pax", price: 4850 },
      { type: "5-8 pax", price: 5400 },
      { type: "9-15 pax", price: 6500 },
      { type: "16-20 pax", price: 7600 },
      { type: "21-24 pax", price: 8700 },
      { type: "25-30 pax", price: 9800 },
    ],
  },
  {
    id: 24,
    name: "Dibatok Island | Boat Rental",
    basePrice: 4300,
    rating: "4.6",
    desc: "A hidden gem with crystal-clear waters, colorful corals, and an untouched paradise vibe.",
    longDescription:
      "Dibatok Island is a small, secluded paradise known for its pristine white sand beaches and excellent snorkeling spots. Explore the diverse marine life, enjoy the peaceful atmosphere, and experience nature at its finest away from the crowds.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "8:00 AM",
    duration: "8 hours",
    imgArray: [`${dibatokIsland}`, `${boatForAll}`],
    variants: [
      { type: "2-4 pax", price: 4300 },
      { type: "5-8 pax", price: 4850 },
      { type: "9-15 pax", price: 5950 },
      { type: "16-20 pax", price: 7050 },
      { type: "21-24 pax", price: 8150 },
      { type: "25-30 pax", price: 9250 },
    ],
  },
  {
    id: 25,
    name: "Calambuyan - Pass Island | Boat Rental",
    basePrice: 5700,
    rating: "4.9",
    desc: "A twin-island experience featuring rich coral gardens, white sand beaches, and tranquil waters.",
    longDescription:
      "Calambuyan and Pass Island offer some of the best snorkeling experiences in the region. Discover vibrant coral reefs, an abundance of tropical fish, and serene beaches perfect for relaxation. Ideal for beach lovers and underwater explorers alike!",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "8:00 AM",
    duration: "8 hours",
    imgArray: [`${passIsland}`, `${boatForAll}`],
    variants: [
      { type: "2-4 pax", price: 5700 },
      { type: "5-8 pax", price: 7000 },
      { type: "9-15 pax", price: 8500 },
      { type: "16-20 pax", price: 9000 },
      { type: "21-24 pax", price: 10000 },
      { type: "25-30 pax", price: 11200 },
    ],
  },
  {
    id: 26,
    name: "Tara Island | Boat Rental",
    basePrice: 11450,
    rating: "4.8",
    desc: "A peaceful retreat with clear waters, beautiful corals, and a relaxing beach ambiance.",
    longDescription:
      "Tara Island is an off-the-beaten-path paradise offering crystal-clear waters, stunning coral formations, and a quiet escape from the busy tourist spots. Enjoy snorkeling, swimming, or simply lounging on its powdery white sand.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "8:00 AM",
    duration: "8 hours",
    imgArray: [`${taraIsland}`, `${boatForAll}`],
    variants: [
      { type: "5-8 pax", price: 11450 },
      { type: "9-15 pax", price: 17500 },
      { type: "16-20 pax", price: 18050 },
      { type: "21-24 pax", price: 19150 },
      { type: "25-30 pax", price: 20250 },
    ],
  },
  {
    id: 27,
    name: "NorthCay - SouthCay | Boat Rental",
    basePrice: 8600,
    rating: "4.9",
    desc: "Twin islands known for their stunning sandbars and crystal-clear blue waters.",
    longDescription:
      "NorthCay and SouthCay are two breathtaking islands featuring long white sandbars, shallow turquoise waters, and abundant marine life. A perfect destination for island-hopping enthusiasts looking for picture-perfect scenery and peaceful relaxation.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "8:00 AM",
    duration: "8 hours",
    imgArray: [`${northCay}`, `${boatForAll}`],
    variants: [
      { type: "5-8 pax", price: 8600 },
      { type: "9-15 pax", price: 9800 },
      { type: "16-20 pax", price: 10350 },
      { type: "21-24 pax", price: 11450 },
      { type: "25-30 pax", price: 12500 },
    ],
  },
  {
    id: 28,
    name: "Calauit | Boat Rental",
    basePrice: 11400,
    rating: "5.0",
    desc: "Explore the wildlife sanctuary in Calauit and the peaceful charm of Panlaitan Island.",
    longDescription:
      "A unique adventure that takes you to Calauit Safari Park, home to African wildlife like giraffes and zebras. Then, visit Panlaitan Island for its serene beaches and breathtaking coastal views.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "7:30 AM",
    duration: "9 hours",
    imgArray: [`${calauitSafari}`, `${boatForAll}`],
    variants: [
      { type: "5-8 pax", price: 11400 },
      { type: "9-15 pax", price: 18000 },
      { type: "16-20 pax", price: 19100 },
      { type: "21-24 pax", price: 20200 },
      { type: "25-30 pax", price: 21300 },
    ],
  },
  {
    id: 29,
    name: "Panlaitan | Boat Rental",
    basePrice: 9200,
    rating: "5.0",
    desc: "Explore the wildlife sanctuary in Calauit and the peaceful charm of Panlaitan Island.",
    longDescription:
      "A unique adventure that takes you to Calauit Safari Park, home to African wildlife like giraffes and zebras. Then, visit Panlaitan Island for its serene beaches and breathtaking coastal views.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "7:30 AM",
    duration: "9 hours",
    imgArray: [`${panlaitan}`, `${boatForAll}`],
    variants: [
      { type: "5-8 pax", price: 9200 },
      { type: "9-15 pax", price: 12500 },
      { type: "16-20 pax", price: 13700 },
      { type: "21-24 pax", price: 14700 },
      { type: "25-30 pax", price: 15800 },
    ],
  },
  {
    id: 30,
    name: "Linapacan | Boat Rental",
    basePrice: 12500,
    rating: "5.0",
    desc: "A remote paradise with some of the clearest waters in the world, perfect for snorkeling and island-hopping.",
    longDescription:
      "Linapacan Island is a dream destination for travelers looking for untouched beauty. The island is famous for its incredibly clear waters, vibrant coral reefs, and secluded beaches. Experience the best of nature in this hidden gem.",
    typeOfTour: "Boat Rental",
    days: "1 Day",
    package: "Day Tour",
    pickUpTime: "7:00 AM",
    duration: "9 hours",
    imgArray: [`${linapacan}`, `${boatForAll}`],
    variants: [
      { type: "5-8 pax", price: 12500 },
      { type: "9-15 pax", price: 18000 },
      { type: "16-20 pax", price: 19000 },
      { type: "21-24 pax", price: 20200 },
      { type: "25-30 pax", price: 21300 },
    ],
  },
  {
    id: 31,
    name: "CORON | 3D2N",
    basePrice: 4700,
    rating: "4.8",
    desc: "A 3-day, 2-night getaway in Coron with island hopping, snorkeling, and breathtaking scenic spots.",
    longDescription:
      "Explore the beauty of Coron with this 3D2N tour package. Enjoy island hopping to world-famous destinations, including crystal-clear lagoons, vibrant coral gardens, and stunning rock formations. This package includes comfortable accommodations, daily breakfast, a buffet lunch, airport transfers, and the assistance of a licensed tour guide. Experience snorkeling, kayaking, and sightseeing in one of the most beautiful destinations in the Philippines.",
    typeOfTour: "3D2N",
    days: "3 days",
    location: "Coron",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [`${snorkeling}`, `${coron}`, `${kayaking}`, `${sightSeeing}`],
    variants: [
      { type: "Adult", price: 4700 },
      { type: "Kid 4-6 years old", price: 2350 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    itinerary: [
      {
        day: 1,
        title: "Arrival + Town Tour",
        destinations: [
          "Lualhati Park",
          "Souvenir Shops",
          "Centennial Shrine",
          "Mt. Tapyas View Deck",
          "Maquinit Hot Spring",
          "Coron Church (Optional)",
        ],
      },
      {
        day: 2,
        title: "Super Ultimate Tour",
        destinations: [
          "Kayangan Lake",
          "Barracuda Lake",
          "Twin Lagoon",
          "Skeleton Wreck",
          "Coral Garden",
          "Smith Beach",
          "CYC Beach",
        ],
      },
      {
        day: 3,
        title: "Departure",
        destinations: [],
      },
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 32,
    name: "EL NIDO | 3D2N",
    basePrice: 4450,
    rating: "4.8",
    desc: "A 3-day, 2-night escape to El Nido, featuring breathtaking lagoons, hidden beaches, and island adventures.",
    longDescription:
      "Experience the pristine beauty of El Nido with this 3D2N package. Immerse yourself in the turquoise waters of Big Lagoon and Small Lagoon, relax on the white sand beaches of Shimizu Island, and marvel at the towering limestone cliffs. This tour includes comfortable accommodations, daily breakfast, a buffet lunch, airport transfers, and a licensed tour guide to make your trip hassle-free and enjoyable. Enjoy snorkeling, kayaking, and sightseeing in one of the most picturesque destinations in Palawan.",
    typeOfTour: "3D2N",
    days: "3 days",
    location: "El Nido",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [`${elNido1}`, `${elNido2}`, `${elNido3}`, `${elNido4}`],
    variants: [
      { type: "Adult", price: 4450 },
      { type: "Kid 4-6 years old", price: 2125 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },
  {
    id: 33,
    name: "PUERTO PRINCESA | 3D2N",
    basePrice: 4950,
    rating: "4.8",
    desc: "A 3-day, 2-night adventure in Puerto Princesa, home to the world-famous Underground River and stunning natural wonders.",
    longDescription:
      "Discover the wonders of Puerto Princesa with this 3D2N tour package. Visit the breathtaking Puerto Princesa Underground River, a UNESCO World Heritage Site, explore the stunning Honda Bay islands, and immerse yourself in the city's vibrant culture. This package includes accommodations, airport transfers, daily breakfast, buffet lunch, and a licensed tour guide to ensure a seamless travel experience. Enjoy activities such as snorkeling, kayaking, and sightseeing in one of Palawan’s most iconic destinations.",
    typeOfTour: "3D2N",
    days: "3 days",
    location: "Puerto Princesa",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [`${puerto1}`, `${puerto2}`, `${puerto3}`, `${puerto4}`],
    variants: [
      { type: "Adult", price: 4950 },
      { type: "Kid 4-6 years old", price: 2475 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
  },

  {
    id: 34,
    name: "Prim Travellers Inn | 3D2N",
    basePrice: 4700,
    rating: "4.8",
    desc: "A budget-friendly 3D2N stay at Prim Travellers Inn with exciting tours in Coron.",
    longDescription:
      "Enjoy a comfortable and affordable 3-day, 2-night stay at Prim Travellers Inn in Coron. This package includes accommodation, guided tours, airport transfers, and meals. Explore Coron’s stunning islands, crystal-clear lagoons, and vibrant marine life through snorkeling and kayaking activities.",
    typeOfTour: "3D2N",
    days: "3 days",
    location: "Coron",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${PrimTravellersInn1}`,
      `${PrimTravellersInn2}`,
      `${PrimTravellersInn3}`,
      `${PrimTravellersInn4}`,
      `${PrimTravellersInn5}`,
      `${PrimTravellersInn6}`,
    ],
    variants: [
      { type: "Adult", price: 4700 },
      { type: "Kid 4-6 years old", price: 2350 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    itinerary: [
      {
        day: 1,
        title: "Arrival + Town Tour",
        destinations: [
          "Lualhati Park",
          "Souvenir Shops",
          "Centennial Shrine",
          "Mt. Tapyas View Deck",
          "Maquinit Hot Spring",
          "Coron Church (Optional)",
        ],
      },
      {
        day: 2,
        title: "Super Ultimate Tour",
        destinations: [
          "Kayangan Lake",
          "Barracuda Lake",
          "Twin Lagoon",
          "Skeleton Wreck",
          "Coral Garden",
          "Smith Beach",
          "CYC Beach",
        ],
      },
      {
        day: 3,
        title: "Departure",
        destinations: [],
      },
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    hotel: "Prim Travellers Inn",
  },
  {
    id: 35,
    name: "Prim Travellers Inn | 3D2N (2)",
    basePrice: 4700,
    rating: "4.8",
    desc: "An upgraded 3D2N experience at Prim Travellers Inn with the Super Ultimate Tour included.",
    longDescription:
      "Enhance your Coron adventure with this premium package at Prim Travellers Inn. This 3D2N stay includes the highly recommended Super Ultimate Tour, featuring breathtaking lagoons, snorkeling in vibrant reefs, and sightseeing at iconic Coron destinations. With airport transfers, delicious meals, and a licensed guide, your trip is made effortless and unforgettable.",
    typeOfTour: "3D2N",
    days: "3 days",
    location: "Coron",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${PrimTravellersInn3}`,
      `${PrimTravellersInn1}`,
      `${PrimTravellersInn2}`,
      `${PrimTravellersInn4}`,
      `${PrimTravellersInn5}`,
      `${PrimTravellersInn6}`,
    ],
    variants: [
      { type: "Adult", price: 4700 },
      { type: "Kid 4-6 years old", price: 2350 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    itinerary: [
      {
        day: 1,
        title: "Arrival + Town Tour",
        destinations: [
          "Lualhati Park",
          "Souvenir Shops",
          "Centennial Shrine",
          "Mt. Tapyas View Deck",
          "Maquinit Hot Spring",
          "Coron Church (Optional)",
        ],
      },
      {
        day: 2,
        title: "Super Ultimate Tour",
        destinations: [
          "Kayangan Lake",
          "Barracuda Lake",
          "Twin Lagoon",
          "Skeleton Wreck",
          "Coral Garden",
          "Smith Beach",
          "CYC Beach",
        ],
      },
      {
        day: 3,
        title: "Departure",
        destinations: [],
      },
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Town Tour"],
    itineraryDay2: ["Super Ultimate Tour"],
    itineraryDay3: ["Departure"],
    hotel: "Prim Travellers Inn",
  },
  {
    id: 36,
    name: "Venus Royale Hotel | 3D2N",
    basePrice: 5900,
    rating: "4.8",
    desc: "A luxurious 3D2N stay at Venus Royale Hotel with top-tier tour experiences in Coron.",
    longDescription:
      "Indulge in a premium 3-day, 2-night stay at Venus Royale Hotel, offering elegance and comfort while you explore Coron. This package includes a comprehensive Super Ultimate Tour, allowing you to visit iconic spots, hidden lagoons, and pristine beaches. Enjoy seamless airport transfers, daily breakfast, buffet lunch, and an expert guide for an unparalleled vacation.",
    typeOfTour: "3D2N",
    days: "3 days",
    location: "Coron",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${VenusRoyaleHotel3}`,
      `${VenusRoyaleHotel1}`,
      `${VenusRoyaleHotel2}`,
      `${VenusRoyaleHotel4}`,
      `${VenusRoyaleHotel5}`,
      `${VenusRoyaleHotel6}`,
      `${VenusRoyaleHotel7}`,
      `${VenusRoyaleHotel8}`,
    ],
    variants: [
      { type: "Adult", price: 5900 },
      { type: "Kid 4-6 years old", price: 2950 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Town Tour"],
    itineraryDay2: ["Super Ultimate Tour"],
    itineraryDay3: ["Departure"],
    hotel: "Venus Royale Hotel",
  },
  {
    id: 37,
    name: "Vienna Hotel | 3D2N",
    basePrice: 5900,
    rating: "4.8",
    desc: "A 3D2N luxurious getaway at Vienna Hotel, offering world-class amenities and exciting island tours.",
    longDescription:
      "Escape to paradise with a 3D2N stay at Vienna Hotel in Coron. This exclusive package includes a Super Ultimate Tour, taking you through stunning lagoons, snorkeling spots, and scenic viewpoints. With airport transfers, premium accommodation, delicious meals, and a licensed tour guide, your trip promises relaxation and adventure in equal measure.",
    typeOfTour: "3D2N",
    days: "3 days",
    location: "Coron",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${ViennaHotel4}`,
      `${ViennaHotel1}`,
      `${ViennaHotel2}`,
      `${ViennaHotel3}`,
      `${ViennaHotel5}`,
    ],
    variants: [
      { type: "Adult", price: 5900 },
      { type: "Kid 4-6 years old", price: 2950 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    hotel: "Vienna Hotel",
  },
  {
    id: 38,
    name: "Budget Accommodation | 4D3N",
    basePrice: 5900,
    rating: "4.6",
    desc: "A budget-friendly adventure in Coron with comfortable accommodations and exciting island-hopping experiences.",
    longDescription:
      "Enjoy a 4-day, 3-night adventure in Coron without breaking the bank. This budget accommodation package includes a well-located stay, daily breakfast, buffet lunch, and guided island tours. Explore the stunning landscapes of Kayangan Lake, Twin Lagoon, and Malcapuya Beach while snorkeling, kayaking, and sightseeing. Perfect for budget-conscious travelers looking for an immersive and enjoyable getaway.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${atwayanBeach}`,
      `${kayanganLake}`,
      `${barracudaLake}`,
      `${twinLagoon}`,
      `${atwayanBeach}`,
      `${cycBeach}`,
    ],
    variants: [
      { type: "Adult", price: 5900 },
      { type: "Kid 4-6 years old", price: 2950 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
  },
  {
    id: 39,
    name: "Prim Travellers Inn | 4D3N",
    basePrice: 5900,
    rating: "4.8",
    desc: "A comfortable and affordable 4-day adventure in Coron, including must-see island destinations and scenic tours.",
    longDescription:
      "Stay at Prim Travellers Inn and embark on a memorable 4-day, 3-night journey in Coron. This package includes accommodations, airport transfers, daily breakfast, and guided tours to Coron’s most breathtaking locations. Experience the Super Ultimate Tour and the Escapade Tour while enjoying fun-filled activities like snorkeling and kayaking. Ideal for travelers looking for both adventure and relaxation.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${PrimTravellersInn4}`,
      `${PrimTravellersInn1}`,
      `${PrimTravellersInn2}`,
      `${PrimTravellersInn3}`,
      `${PrimTravellersInn5}`,
      `${PrimTravellersInn6}`,
    ],
    variants: [
      { type: "Adult", price: 5900 },
      { type: "Kid 4-6 years old", price: 2950 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: ["Super Ultimate Tours"],
    itineraryDay3: ["Escapade Tour"],
    itineraryDay4: ["Departure"],
    hotel: "Prim Travellers Inn",
  },
  {
    id: 40,
    name: "Vienna Hotel | 4D3N",
    basePrice: 8500,
    rating: "4.8",
    desc: "A relaxing 4D3N Coron trip featuring a stay at Vienna Hotel and thrilling island tours.",
    longDescription:
      "Treat yourself to a 4-day, 3-night stay at Vienna Hotel while exploring Coron’s top attractions. This package includes comfortable accommodations, airport transfers, breakfast, and guided island tours. Discover the beauty of Kayangan Lake, Twin Lagoon, and the Escapade Tour’s pristine beaches while engaging in fun activities such as snorkeling and kayaking. Perfect for those seeking a balance between comfort and adventure.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${ViennaHotel2}`,
      `${ViennaHotel1}`,
      `${ViennaHotel3}`,
      `${ViennaHotel4}`,
      `${ViennaHotel5}`,
    ],
    variants: [
      { type: "Adult", price: 8500 },
      { type: "Kid 4-6 years old", price: 4250 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: ["Super Ultimate Tours"],
    itineraryDay3: ["Escapade Tour"],
    itineraryDay4: ["Departure"],
    hotel: "Vienna Hotel",
  },
  {
    id: 41,
    name: "Sunz en Coron | 4D3N",
    basePrice: 8800,
    rating: "4.8",
    desc: "Experience a 4D3N stay at Sunz en Coron, complete with premium amenities and top-rated island tours.",
    longDescription:
      "Enjoy an unforgettable 4-day, 3-night trip while staying at Sunz en Coron, featuring pool access and free Wi-Fi. This package offers a city tour on arrival, daily breakfast, and access to Coron’s best island destinations through the Super Ultimate and Island Escapade Tours. Dive into crystal-clear waters, snorkel among vibrant corals, and capture breathtaking moments at scenic spots. Ideal for travelers who want both relaxation and adventure.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${SunzEnCoron1}`,
      `${SunzEnCoron2}`,
      `${SunzEnCoron3}`,
      `${SunzEnCoron4}`,
    ],
    variants: [
      { type: "Adult", price: 8800 },
      { type: "Kid 4-6 years old", price: 4400 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + City Tour"],
    itineraryDay2: ["Super Ultimate Tours"],
    itineraryDay3: ["Island Escapade Tour"],
    itineraryDay4: ["Departure"],
    hotel: "Sunz en Coron",
  },
  {
    id: 42,
    name: "Venus Royale Hotel | 4D3N",
    basePrice: 8800,
    rating: "4.8",
    desc: "A 4D3N luxurious stay at Venus Royale Hotel paired with exhilarating island adventures.",
    longDescription:
      "Stay at Venus Royale Hotel and experience a 4-day, 3-night getaway in Coron. This package includes elegant accommodations, airport transfers, daily breakfast, and guided tours to iconic sites like Kayangan Lake and Twin Lagoon. Enjoy snorkeling, kayaking, and sightseeing while immersing yourself in the natural wonders of Coron. Perfect for those who seek both comfort and adventure.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${VenusRoyaleHotel5}`,
      `${VenusRoyaleHotel1}`,
      `${VenusRoyaleHotel2}`,
      `${VenusRoyaleHotel3}`,
      `${VenusRoyaleHotel4}`,
      `${VenusRoyaleHotel6}`,
      `${VenusRoyaleHotel7}`,
      `${VenusRoyaleHotel8}`,
    ],
    variants: [
      { type: "Adult", price: 8800 },
      { type: "Kid 4-6 years old", price: 4400 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    hotel: "Venus Royale Hotel",
  },
  {
    id: 43,
    name: "Venus Royale Hotel | 4D3N (2)",
    basePrice: 8900,
    rating: "4.8",
    desc: "A premium 4D3N experience at Venus Royale Hotel with exclusive island tours.",
    longDescription:
      "Upgrade your Coron experience with a premium stay at Venus Royale Hotel. This 4-day, 3-night package includes high-end accommodations, airport transfers, and well-planned island tours. Enjoy the Super Ultimate Tour and the Island Escapade Tour, where you’ll witness breathtaking seascapes, go snorkeling, and relax on white-sand beaches. Ideal for those looking for a touch of luxury during their adventure.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${VenusRoyaleHotel6}`,
      `${VenusRoyaleHotel5}`,
      `${VenusRoyaleHotel1}`,
      `${VenusRoyaleHotel2}`,
      `${VenusRoyaleHotel3}`,
      `${VenusRoyaleHotel4}`,
      `${VenusRoyaleHotel7}`,
      `${VenusRoyaleHotel8}`,
    ],
    variants: [
      { type: "Adult", price: 8900 },
      { type: "Kid 4-6 years old", price: 4450 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: ["Super Ultimate Tours"],
    itineraryDay3: ["Island Escapade Tour"],
    itineraryDay4: ["Departure"],
    hotel: "Venus Royale Hotel",
  },
  {
    id: 44,
    name: "Westown Hotel | 4D3N",
    basePrice: 12800,
    rating: "4.8",
    desc: "A luxurious 4D3N stay at Westown Hotel, offering top-tier comfort and thrilling island tours.",
    longDescription:
      "Experience Coron in style with a 4-day, 3-night stay at Westown Hotel. This package features premium accommodations, airport transfers, breakfast, and guided island tours. Visit the stunning Kayangan Lake, Twin Lagoon, and enjoy a relaxing time at Ditaytayan Beach. Engage in activities such as snorkeling, kayaking, and sightseeing. This is an ideal package for those looking for an elegant and adventure-filled vacation.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${WestownHotel3}`,
      `${WestownHotel1}`,
      `${WestownHotel2}`,
      `${WestownHotel4}`,
      `${snorkeling}`,
      `${kayaking}`,
      `${sightSeeing}`,
      `${pictureTaking}`,
      `${kayanganLake}`,
      `${barracudaLake}`,
      `${twinLagoon}`,
      `${atwayanBeach}`,
      `${cycBeach}`,
      `${malcapuyaBeach}`,
      `${ditaytayanBeach}`,
    ],
    variants: [
      { type: "Adult", price: 12800 },
      { type: "Kid 4-6 years old", price: 6400 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "Westown Hotel",
  },
  {
    id: 45,
    name: "Westown Lagoon | 4D3N (2)",
    basePrice: 12800,
    rating: "4.8",
    desc: "A serene and comfortable 4D3N stay at Westown Lagoon with exciting Coron adventures.",
    longDescription:
      "Relax in the tranquility of Westown Lagoon while experiencing the best of Coron. This 4-day, 3-night package includes deluxe accommodations, airport transfers, breakfast, and guided island-hopping tours. Enjoy breathtaking views at Barracuda Lake, Twin Lagoon, and Malcapuya Beach while partaking in snorkeling and kayaking activities. A great option for travelers who want a balance of comfort and exploration.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${WestownLagoon1}`,
      `${WestownLagoon2}`,
      `${kayanganLake}`,
      `${barracudaLake}`,
      `${twinLagoon}`,
      `${atwayanBeach}`,
      `${cycBeach}`,
      `${malcapuyaBeach}`,
      `${ditaytayanBeach}`,
    ],
    variants: [
      { type: "Adult", price: 12800 },
      { type: "Kid 4-6 years old", price: 6400 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "Westown Lagoon",
  },
  {
    id: 58,
    name: "Sunlight Hotel | 4D3N",
    basePrice: 15800,
    rating: "4.8",
    desc: "Experience a 4-day tropical getaway in Coron, with a luxurious stay at Sunlight Hotel and breathtaking island-hopping adventures.",
    longDescription:
      "Embark on a 4-day, 3-night vacation at Sunlight Hotel, a perfect blend of comfort and adventure in Coron. This package includes stylish accommodations, seamless airport transfers, and daily breakfast, along with guided tours to some of the most stunning attractions, including Kayangan Lake, Twin Lagoon, and Malcapuya Island. With premium amenities, scenic views, and exciting island excursions, this trip promises a rejuvenating escape in paradise.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${SunLightHotel1}`,
      `${SunLightHotel2}`,
      `${SunLightHotel3}`,
      `${kayaking}`,
      `${kayanganLake}`,
      `${barracudaLake}`,
      `${cycBeach}`,
      `${atwayanBeach}`,
      `${snorkeling}`,
      `${ditaytayanBeach}`,
    ],
    variants: [
      { type: "Adult", price: 15800 },
      { type: "Kid 4-6 years old", price: 7900 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "Sunlight Hotel",
  },
  {
    id: 46,
    name: "Bacau Bay Resort | 4D3N",
    basePrice: 16000,
    rating: "4.8",
    desc: "A luxurious 4-day escape in Coron, offering a serene stay with premium amenities and breathtaking island tours.",
    longDescription:
      "Indulge in a 4-day, 3-night getaway at Bacau Bay Resort, where modern comforts meet island paradise. This package includes well-appointed accommodations, airport transfers, daily breakfast, and guided tours to iconic destinations like Kayangan Lake, Twin Lagoon, and Malcapuya Island. Enjoy a perfect mix of relaxation and adventure in one of Coron’s finest hotels.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${BacauBay1}`,
      `${BacauBay2}`,
      `${BacauBay3}`,
      `${BacauBay4}`,
      `${kayaking}`,
      `${kayanganLake}`,
      `${barracudaLake}`,
      `${cycBeach}`,
    ],
    variants: [
      { type: "Adult", price: 16000 },
      { type: "Kid 4-6 years old", price: 8000 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "Bacau Bay Resort",
  },
  {
    id: 47,
    name: "The Funny Lion | 4D3N",
    basePrice: 16400,
    rating: "4.8",
    desc: "An intimate and stylish 4-day retreat in Coron, featuring top-tier amenities and immersive island tours.",
    longDescription:
      "Experience the charm of The Funny Lion with a 4-day, 3-night stay in a boutique hotel known for its cozy ambiance and exceptional service. This package includes comfortable accommodations, airport transfers, daily breakfast, and adventure-packed tours to Coron’s most picturesque spots, including the famed Barracuda Lake and Coral Garden.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${FunnyLion1}`,
      `${FunnyLion2}`,
      `${FunnyLion3}`,
      `${FunnyLion4}`,
      `${atwayanBeach}`,
      `${barracudaLake}`,
      `${cycBeach}`,
      `${ditaytayanBeach}`,
    ],
    variants: [
      { type: "Adult", price: 16400 },
      { type: "Kid 4-6 years old", price: 8200 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "The Funny Lion",
  },
  {
    id: 48,
    name: "Zuri Resort | 4D3N",
    basePrice: 17000,
    rating: "4.8",
    desc: "A sophisticated 4-day tropical escape with a lavish resort stay and mesmerizing island excursions.",
    longDescription:
      "Stay at Zuri Resort for an unforgettable 4-day, 3-night adventure in Coron. This package includes luxury accommodations, seamless airport transfers, gourmet breakfast, and exclusive island tours covering top attractions like the Blue Lagoon, Banol Beach, and Skeleton Wreck. Enjoy premium comfort paired with thrilling island activities.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${Zuri1}`,
      `${Zuri2}`,
      `${Zuri3}`,
      `${Zuri4}`,
      `${Zuri5}`,
      `${Zuri6}`,
      `${snorkeling}`,
      `${sightSeeing}`,
      `${pictureTaking}`,
    ],
    variants: [
      { type: "Adult", price: 17000 },
      { type: "Kid 4-6 years old", price: 8500 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "Zuri Resort",
  },
  {
    id: 49,
    name: "Tag Resort | 4D3N",
    basePrice: 18000,
    rating: "4.8",
    desc: "A relaxing 4-day island retreat, blending modern elegance with exciting Coron island-hopping adventures.",
    longDescription:
      "Unwind at Tag Resort with a 4-day, 3-night stay that combines comfort and adventure. This package features stylish accommodations, airport transfers, daily breakfast, and guided excursions to Coron’s must-see locations, including Siete Pecados, Kayangan Lake, and Maquinit Hot Springs. Perfect for travelers seeking both relaxation and exploration.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${TagResort1}`,
      `${TagResort2}`,
      `${TagResort3}`,
      `${sightSeeing}`,
      `${pictureTaking}`,
      `${ditaytayanBeach}`,
      `${atwayanBeach}`,
      `${twinLagoon}`,
    ],
    variants: [
      { type: "Adult", price: 18000 },
      { type: "Kid 4-6 years old", price: 9000 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "Tag Resort",
  },
  {
    id: 50,
    name: "Two Season Bayside | 4D3N",
    basePrice: 18000,
    rating: "4.8",
    desc: "An upscale 4-day island retreat at Two Season Bayside, featuring top-tier comfort and exhilarating island tours.",
    longDescription:
      "Experience the ultimate getaway at Two Season Bayside with a 4-day, 3-night stay in one of Coron’s most luxurious resorts. This package includes high-end accommodations, private airport transfers, sumptuous breakfast, and guided island tours showcasing breathtaking sites like Bulog Dos, Banana Island, and Black Island. A perfect blend of tranquility and adventure awaits.",
    typeOfTour: "4D3N",
    days: "4 days",
    location: "Coron",
    package: "4D3N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${TwoSeason1}`,
      `${TwoSeason2}`,
      `${TwoSeason3}`,
      `${TwoSeason4}`,
      `${kayaking}`,
      `${pictureTaking}`,
      `${twinLagoon}`,
    ],
    variants: [
      { type: "Adult", price: 18000 },
      { type: "Kid 4-6 years old", price: 9000 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
      "Pool Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: ["Departure"],
    hotel: "Two Season Bayside",
  },
  {
    id: 51,
    name: "Prim Travellers Inn | 5D4N",
    basePrice: 7500,
    rating: "4.6",
    desc: "A budget-friendly 5-day, 4-night getaway in Coron with island-hopping and guided tours.",
    longDescription:
      "Enjoy a 5-day, 4-night stay at Prim Travellers Inn, perfect for travelers looking for affordability and adventure. This package includes comfortable accommodations, airport transfers, daily breakfast, and exciting guided tours, including Tour A, Tour B, and an Island Escapade Tour. Experience Coron’s stunning beaches, crystal-clear waters, and breathtaking lagoons while engaging in activities like snorkeling and sightseeing.",
    typeOfTour: "5D4N",
    days: "5 days",
    location: "Coron",
    package: "5D4N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${PrimTravellersInn5}`,
      `${PrimTravellersInn1}`,
      `${PrimTravellersInn2}`,
      `${PrimTravellersInn3}`,
      `${PrimTravellersInn4}`,
      `${PrimTravellersInn6}`,
      `${kayaking}`,
      `${snorkeling}`,
      `${pictureTaking}`,
    ],
    variants: [
      { type: "Adult", price: 7500 },
      { type: "Kid 4-6 years old", price: 3750 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: ["Tour A"],
    itineraryDay3: ["Tour B"],
    itineraryDay4: ["Island Escapade Tour"],
    itineraryDay5: ["Departure"],
    hotel: "Prim Travellers Inn",
  },
  {
    id: 52,
    name: "Vienna Hotel | 5D4N",
    basePrice: 11200,
    rating: "4.8",
    desc: "A premium 5-day Coron adventure with island tours and luxurious accommodations.",
    longDescription:
      "Stay at Vienna Hotel and enjoy a well-curated 5-day, 4-night Coron experience. This package offers high-end accommodations, hassle-free airport transfers, and daily breakfast. Explore Coron’s famous spots through Tour A, Tour B, and an Island Escapade Tour. Experience island hopping, snorkeling, and sightseeing at stunning destinations like Kayangan Lake, Twin Lagoon, and Malcapuya Beach.",
    typeOfTour: "5D4N",
    days: "5 days",
    location: "Coron",
    package: "5D4N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${ViennaHotel3}`,
      `${ViennaHotel1}`,
      `${ViennaHotel2}`,
      `${ViennaHotel4}`,
      `${ViennaHotel5}`,
      `${cycBeach}`,
      `${kayaking}`,
      `${sightSeeing}`,
      `${pictureTaking}`,
    ],
    variants: [
      { type: "Adult", price: 11200 },
      { type: "Kid 4-6 years old", price: 5600 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: ["Tour A"],
    itineraryDay3: ["Tour B"],
    itineraryDay4: ["Island Escapade Tour"],
    itineraryDay5: ["Departure"],
    hotel: "Vienna Hotel",
  },
  {
    id: 53,
    name: "Venus Royale Hotel | 5D4N",
    basePrice: 11300,
    rating: "4.9",
    desc: "A relaxing and adventure-filled 5-day trip with premium hotel accommodations in Coron.",
    longDescription:
      "Book a 5-day, 4-night stay at Venus Royale Hotel and explore Coron’s most scenic destinations. This package includes high-quality accommodations, convenient airport transfers, and guided tours covering Tour A, Tour B, and the Island Escapade Tour. Discover the beauty of Kayangan Lake, Barracuda Lake, and Malcapuya Beach while enjoying activities like snorkeling, kayaking, and sightseeing.",
    typeOfTour: "5D4N",
    days: "5 days",
    location: "Coron",
    package: "5D4N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${VenusRoyaleHotel2}`,
      `${VenusRoyaleHotel6}`,
      `${VenusRoyaleHotel5}`,
      `${VenusRoyaleHotel1}`,
      `${VenusRoyaleHotel3}`,
      `${VenusRoyaleHotel4}`,
      `${VenusRoyaleHotel7}`,
      `${VenusRoyaleHotel8}`,
    ],
    variants: [
      { type: "Adult", price: 11300 },
      { type: "Kid 4-6 years old", price: 5650 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    hotel: "Venus Royale Hotel",
  },
  {
    id: 54,
    name: "Venus Royale Hotel | 5D4N (2)",
    basePrice: 11600,
    rating: "4.7",
    desc: "An upgraded 5-day Coron experience with added comfort and adventure.",
    longDescription:
      "Experience a luxurious 5-day, 4-night stay at Venus Royale Hotel, offering premium comfort and seamless travel services. This package includes upgraded accommodations, airport transfers, and guided island tours covering the best spots in Coron. Explore Kayangan Lake, Twin Lagoon, and Malcapuya Beach while indulging in snorkeling, sightseeing, and boat rides across turquoise waters.",
    typeOfTour: "5D4N",
    days: "5 days",
    location: "Coron",
    package: "5D4N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${VenusRoyaleHotel7}`,
      `${VenusRoyaleHotel6}`,
      `${VenusRoyaleHotel5}`,
      `${VenusRoyaleHotel1}`,
      `${VenusRoyaleHotel4}`,
      `${VenusRoyaleHotel2}`,
      `${VenusRoyaleHotel3}`,
      `${VenusRoyaleHotel8}`,
    ],
    variants: [
      { type: "Adult", price: 11600 },
      { type: "Kid 4-6 years old", price: 5600 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: ["Tour A"],
    itineraryDay3: ["Tour B"],
    itineraryDay4: ["Island Escapade Tour"],
    itineraryDay5: ["Departure"],
    hotel: "Venus Royale Hotel",
  },
  {
    id: 55,
    name: "Vienna Hotel | 5D4N (2)",
    basePrice: 11800,
    rating: "4.7",
    desc: "A premium Coron experience with a city tour and extended island hopping adventures.",
    longDescription:
      "Stay at Vienna Hotel for 5 days and 4 nights and enjoy a luxurious getaway featuring a city tour and extended island-hopping adventures. This package includes comfortable accommodations, airport transfers, and fully guided tours. Visit Coron’s top attractions, including Lualhati Park, Kayangan Lake, and Lusong Coral Garden. Enjoy activities like snorkeling, sightseeing, and exploring hidden beach paradises.",
    typeOfTour: "5D4N",
    days: "5 days",
    location: "Coron",
    package: "5D4N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${snorkeling}`,
      `${centennialShrine}`,
      `${maquinitHotspring}`,
      `${sightSeeing}`,
      `${kayaking}`,
      `${coronChurch}`,
      `${mtTapyas}`,
      `${souvenirShop}`,
      `${lualhatiPark}`,
    ],
    variants: [
      { type: "Adult", price: 11800 },
      { type: "Kid 4-6 years old", price: 5900 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: [
      "Day 1 Arrival + City Tour",
      "Lualhati Park",
      "Souvenir Shop",
      "Kaulayaw Coffee",
      "Centennial Shrine",
      "Mt. Tapyas View Deck",
      "Maquinit Hotspring",
      "Coron Church (Optional)",
    ],
    itineraryDay2: [
      "Kayangan Lake",
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Coral Garden",
      "Atwayan Beach or Shaniah Cottage",
      "CYC Beach",
    ],
    itineraryDay3: ["Malcapuya Beach", "Banana Beach", "Ditaytayan Beach"],
    itineraryDay4: [
      "Pass Island",
      "Lusong Gunboat",
      "Lusong Coral Garden",
      "East Tangat Wreck",
    ],
    itineraryDay5: ["Departure"],
    hotel: "Vienna Hotel",
  },
  {
    id: 56,
    name: "Venus Royale Hotel | 6D5N",
    basePrice: 15000,
    rating: "4.7",
    desc: "",
    longDescription: "",
    typeOfTour: "6D5N",
    days: "6 days",
    location: "Coron",
    package: "6D5N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${VenusRoyaleHotel4}`,
      `${VenusRoyaleHotel6}`,
      `${VenusRoyaleHotel5}`,
      `${VenusRoyaleHotel1}`,
      `${VenusRoyaleHotel2}`,
      `${VenusRoyaleHotel3}`,
      `${VenusRoyaleHotel7}`,
      `${VenusRoyaleHotel8}`,
    ],
    variants: [
      { type: "Adult", price: 15000 },
      { type: "Kid 4-6 years old", price: 7500 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],

    hotel: "Venus Royale Hotel",
  },
  {
    id: 57,
    name: "Vienna Hotel | 7D6N",
    basePrice: 16000,
    rating: "4.7",
    desc: "",
    longDescription: "",
    typeOfTour: "7D6N",
    days: "7 days",
    location: "Coron",
    package: "7D6N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${ViennaHotel1}`,
      `${ViennaHotel2}`,
      `${ViennaHotel3}`,
      `${ViennaHotel4}`,
      `${ViennaHotel5}`,
      `${snorkeling}`,
      `${kayaking}`,
      `${sightSeeing}`,
      `${pictureTaking}`,
      `${kayanganLake}`,
      `${greenLagoon}`,
      `${cycBeach}`,
      `${lasIslaDeCoral}`,
      `${barracudaLake}`,
      `${twinLagoon}`,
      `${banolBeach}`,
    ],
    variants: [
      { type: "Adult", price: 16000 },
      { type: "Kid 4-6 years old", price: 8000 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Accommodation",
      "Airport Transfer (Vice Versa)",
      "Breakfast",
      "Buffet Lunch",
      "Entrance Fee",
      "Licensed Tour Guide",
      "Tourist Boat",
      "Pick up and Drop off Service",
      "Free Wi-Fi Access",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    itineraryDay1: ["Day 1 Arrival + Free Time"],
    itineraryDay2: [
      "Kayangan Lake",
      "Green Lagoon",
      "CYC Beach",
      "Las Islas De coral",
      "White Beach",
    ],
    itineraryDay3: [
      "Barracuda Lake",
      "Twin Lagoon",
      "Skeleton Wreck",
      "Banol Beach/ Balinsasayaw Beach",
      "Reef Garden",
    ],
    itineraryDay4: ["Malcapuya Island", "Banana Island", "Bulog Dos"],
    itineraryDay5: [
      "Pass Island",
      "Lusong Gunboat",
      "East Tangat",
      "Coral Garden",
    ],
    itineraryDay6: [
      "Town Tour",
      "Lualhati Park",
      "Souvenir Shop",
      "Centennial Shrine",
      "Mt. Tapyas View Deck",
      "Maquinit Hotspring",
    ],
    itineraryDay7: ["Departure"],
    hotel: "Vienna Hotel",
  },
  {
    id: 58,
    name: "Coron to El Nido Expedition",
    basePrice: 15000,
    rating: "5",
    desc: "Discover breathtaking places with our exclusive travel packages, tailored just for you.",
    longDescription: "",
    typeOfTour: "Expedition",
    days: "3 days",
    location: "Coron & El Nido",
    package: "3D2N",
    pickUpTime: "8:00-8:30 AM",
    duration: "9 hours",
    imgArray: [
      `${elNido3}`,
      `${coron}`,
      `${elNido1}`,
      `${elNido2}`,
      `${elNido4}`,
      `${kayaking}`,
      `${pictureTaking}`,
      `${sightSeeing}`,
      `${snorkeling}`,
      `${ditaytayanBeach}`,
      `${culion}`,
    ],
    variants: [
      { type: "Adult", price: 15000 },
      { type: "Kid 4-6 years old", price: 7500 },
      { type: "Infant 3 years old and below", price: 0 },
    ],
    inclusions: [
      "Entrance",
      "Environmental Fees",
      "Beach Camp Accomodation (Bahay Kubo or Nipa Hut with Comfortable Mattress)",
      "Meals and Snacks (Filipino Cuisine with Seafood and Vegetarian Options",
      "Drinking Water, Soft Drinks and Alcoholic Beverages",
      "Mask and Snorkles, Kayak, Life Jacket , First Aid Box",
      "Free Electric Charging and Wi-Fi",
      "Bonfire and Fire Dance Show",
    ],
    activities: ["Snorkeling", "Kayaking", "Sight Seeing", "Picture Taking"],
    destinations: [
      "Ditaytayan Sand Bar",
      "Ditaytayan Long Beach Camp",
      "Coral Garden",
      "Araw Beach",
      "Culion Beach Camp",
      "Buko Island",
      "Anapupuan Fisherman Village",
      "Double 9 Cliff Jumping",
      "Cagdanao Desserted Island",
      "Linapacan Beach Camp",
      "Bulawit Turtle Conservation Area",
      "Cobra Island",
      "Tacling Island",
      "Daracutan Shipwreck",
      "El Nido San Fernando ETA 5:30 PM",
    ],
  },
];

export default tours;
